import { ReactElement } from 'react'

import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

import { SETTINGS_GENERAL } from '@/config/settings.general'
import { useReachGoal } from '@/hooks/useReachGoal'

import big from './images/big.webp'
import min from './images/min.webp'
import styles from './styles.module.scss'

export default function ToTelegramBanner(): ReactElement {
    const reachGoal = useReachGoal()

    const pathname = usePathname()

    return (
        <Link
            href={SETTINGS_GENERAL.SOCIAL_TELEGRAM_LINK}
            target={'_blank'}
            className={styles.banner}
            onClick={() =>
                reachGoal({
                    type: 'params',
                    goalName: 'click-banner-telegram',
                    params: {
                        url: pathname,
                    },
                })
            }
        >
            <Image
                src={big}
                alt={'Перейти в Telegram'}
                className={styles.banner__big}
                draggable={false}
            />
            <Image
                src={min}
                alt={'Перейти в Telegram'}
                className={styles.banner__min}
                draggable={false}
            />
        </Link>
    )
}
